<h2 style="text-align: center;margin-top:-20px;margin-bottom:20px;background-color:rgb(4, 73, 15);color:white;padding:5px;padding-top:20px">
    Sensor Simulator
</h2>

<div *ngIf="showSelection" class="container" style="max-width:350px">
    <div style="height: 30px"></div>
    <h3 style="text-align:center;color:grey">Hazmat Sensor Simulator</h3><br>
    <div class="container" style="max-width:250px;padding:0px">
        <div style="height: 15px"></div>
        <div>Enter Scenario Id</div>
        <div style="height: 15px"></div>
        <input type="text" [(ngModel)]="scenarioid" placeholder="Scenario id" style="padding:10px;width:100%">
        <div style="height: 10px"></div>
        <input type="text" [(ngModel)]="teamname" placeholder="Team (optional)" style="padding:10px;width:100%">
        <div style="height: 10px"></div>
        <button style="width:100%;background-color:rgb(4, 73, 15);color:white;padding:10px" (click)="debug = false; start()">Submit</button>
        <!-- <br><br><br>
        <sa-input-text [(text)]="scenarioid" [title]="'Enter Scenario Number'" [required]="'none'"></sa-input-text>
        <br><br>
        <sa-input-text [(text)]="teamname" [title]="'Enter Team Name (optional)'" [required]="'none'"></sa-input-text> -->

        <div style="position: absolute;bottom: 0;width:100%;padding-right:10px">
            <div style="padding:10px;float:right">
                Version 2.0<br>
                5/22/2023
            </div>
        </div>

    </div>

</div>

<div *ngIf="!showSelection">
    <div class="blink" [style.background-color]="alarmColor" style="width:100%;"> .</div>
    <div style="height:70px"></div>
    <div *ngFor="let s of scenariosensors" style="max-width:100%">
        <div style="width:20%;display:inline-block;text-align:center;margin:5px;margin-left:30px">{{s.sensorname}}:</div>
        <div style="width:30%;border:solid 1px gray;display:inline-block;text-align:center;margin:5px" [ngStyle]="{'background-color': s.alarm ? '#ffb3b3' : 'white'}">
            {{s.reading | number: '1.1-1'}}
        </div>
        <div style="width:20%;display:inline-block;text-align:center">{{s.sensorunits}}:</div>

    </div>
    <div style="position: absolute;bottom: 0;width:100%">
        <div class="blink" [style.background-color]="alarmColor" style="width:100%"> .</div>
        <div style="padding:10px">
            <div>
                <button (click)="stop()" style="width:100%;background-color:rgb(4, 73, 15);color:white;padding:10px">Stop</button>
            </div>
            <br>
            <div *ngIf="!hasFirstGPSSignal" style="background-color: orange;width:100%">No GPS Signal Received</div>
            <div> {{gpslog.phoneinfo}} with {{counter}} GPS; height: {{gpslog.height | number: '1.1-1'}} Acc {{currentAccuracy | number:'1.1-1'}} V 2.4</div>
        </div>
    </div>

</div>

<!-- <div *ngIf="false">
    Debug={{debug}}, Counter: {{counter}}, Distance: {{distance | number: '1.1-1'}}, in contour
    <span *ngIf="scenariolayout.contours.length > 0">{{currentContourId}}, value{{scenariolayout.contourdefinitions[currentContourId].exposure}}</span>
    <div #pagemap style="width:100%;height:400px"></div>
    <button class="btn btn-primary inline" (click)="debug = true; start()">Start Debug</button>
</div> -->

<audio #audioPlayer [src]="audioSrc" loop volume="0.0"></audio>